import { render, staticRenderFns } from "./App.vue?vue&type=template&id=55fe8ef3&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=55fe8ef3&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=55fe8ef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fe8ef3",
  null
  
)

export default component.exports